﻿import { DataRequest } from 'shared/data/datarequest';

export class SaveResult {
    static $type = 'Web.SaveResult';

    dataChanges: DataRequest[];

    versionId: string;
}